(function () {
  'use strict';
  if (customElements.get('biancelle-product-motion')) return;
  class BiancelleProductMotion extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-bi-motion-toggle]');
      this.list = this.querySelector('.product__media-list');
      if (!this.button || !this.list) return;
      this.paused = false;
      this.visible = !('IntersectionObserver' in window);
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onToggle = () => { this.paused = !this.paused; this.sync(); };
      this.onPreference = this.sync.bind(this);
      this.onVisibility = this.sync.bind(this);
      this.button.addEventListener('click', this.onToggle);
      this.reduced.addEventListener('change', this.onPreference);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.observer = new MutationObserver(records => {
        // Ignore our own marker and unrelated gallery class changes.
        const changed = records.some(record => record.type === 'childList' ||
          (record.target.matches('.product__media-item') &&
            (record.oldValue || '').split(/\s+/).includes('is-active') !== record.target.classList.contains('is-active')));
        if (changed) this.sync();
      });
      this.observer.observe(this.list, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class'], attributeOldValue: true
      });
      if ('IntersectionObserver' in window) {
        this.intersection = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: .1 });
        this.intersection.observe(this.list);
      }
      this.sync();
    }
    sync() {
      if (!this.list || !this.button) return;
      const active = this.list.querySelector('.product__media-item.is-active') || this.list.querySelector('.product__media-item');
      const image = active && active.querySelector('.product__modal-opener--image img');
      const nextItem = image ? active : null;
      if (this.activeItem !== nextItem) {
        this.activeItem?.classList.remove('bi-motion-active');
        nextItem?.classList.add('bi-motion-active');
        this.activeItem = nextItem;
      }
      const playing = !!image && this.visible && !document.hidden && !this.paused && !this.reduced.matches;
      if (this.classList.contains('is-playing') !== playing) this.classList.toggle('is-playing', playing);
      const hidden = !image || this.reduced.matches;
      if (this.button.hidden !== hidden) this.button.hidden = hidden;
      const pressed = String(this.paused);
      if (this.button.getAttribute('aria-pressed') !== pressed) this.button.setAttribute('aria-pressed', pressed);
      const label = this.paused ? 'Pornește animația' : 'Oprește animația';
      if (this.button.textContent !== label) this.button.textContent = label;
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.intersection) this.intersection.disconnect();
      this.activeItem?.classList.remove('bi-motion-active');
      this.activeItem = null;
      this.classList.remove('is-playing');
      if (this.button) this.button.removeEventListener('click', this.onToggle);
      if (this.reduced) this.reduced.removeEventListener('change', this.onPreference);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
  }
  customElements.define('biancelle-product-motion', BiancelleProductMotion);
})();
